import Layout from "../include/layout";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import "datatables.net-bs5";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import PeriodicitesScolairesService from "./PeriodicitesScolairesService";
import AnneesacademiquesIndex from "../anneesacademiques";
import AnneesacademiquesService from "../anneesacademiques/AnneesacademiquesService";

export default function PeriodicitesScolairesIndex() {
  const activeLink = "PÉRIODICITÉS SCOLAIRES"

  const token = useSelector((state) => state.auth.token);
  const [periodicites, setPeriodicites] = useState([]);
  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const [anneesacademiques, setAnneeAcademiques] = useState([]);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  const [errors, setErrors] = useState({});

  const [isVisible, setIsVisible] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [addFormData, setAddFormData] = useState({
    libellePeriodiciteScolaire: '',
    descriptionPeriodiciteScolaire: '',
    dateDebutPeriodiciteScolaire: '',
    dateFinPeriodiciteScolaire: '',
    anneeacademiqueId: '',
  });

  //declaration des variables pour le form d'edition
  const [editFormData, setEditFormData] = useState({
    libellePeriodiciteScolaire: '',
    descriptionPeriodiciteScolaire: '',
    dateDebutPeriodiciteScolaire: '',
    dateFinPeriodiciteScolaire: '',
    anneeacademiqueId: '',
    id: ''
  });
  //console.log(addFormData);

  //get liste periodicitesscolaires
  const fetchPeriodicites = async () => {
    await PeriodicitesScolairesService.index(token).then((res) => {
      //console.log(res.data.data)
      setPeriodicites(res.data.data.periodicitesscolaires);
    })
      .catch((error) => {
        console.log(error);
      });

    //initialize datatable
    $(document).ready(function () {
      $(".data-table").DataTable();
    });
  };

  //get liste annesacademiques
  const fetchAnneeacademique = async () => {
    await AnneesacademiquesService.index(token).then((res) => {
      console.log(res.data)
      setAnneeAcademiques(res.data.data.anneesacademiques || [])
      console.log('annes',res.data.data.anneesacademiques)
    }).catch(error => {
      console.log(error)
    })

    //initialize datatable
    $(document).ready(function () {
      $('.data-table').DataTable();
    });
  }

  //####GESTION DES REGLES DE VALIDATIONS ###########///
  const schemaAddData = {
    libellePeriodiciteScolaire: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionPeriodiciteScolaire: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),

    dateDebutPeriodiciteScolaire: Joi.date().required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Date Debut"),

    dateFinPeriodiciteScolaire: Joi.date().required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Date Fin"),

    anneeacademiqueId: Joi.number().required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Année Academique")
  };

  //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
  const schemaEditData = {

    libellePeriodiciteScolaire: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionPeriodiciteScolaire: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),

    dateDebutPeriodiciteScolaire: Joi.date().required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Date Debut"),

    dateFinPeriodiciteScolaire: Joi.date().required().empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Date Fin"),

    anneeacademiqueId: Joi.number().required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
      },
    }).label("Année Academique"),

    id: Joi.number().min(1).empty('').options({
      language: {
        string: { min: "minimum 1" },
      },
    }).label("Id")
  };

  //####END GESTION DES REGLES DE VALIDATIONS ###########///
  const handleChange = (event) => {
    const { name, value } = event.target;

    const updatedValue = name === 'anneeacademiqueId' ? parseInt(value) : value;

    setAddFormData((prevData) => ({ ...prevData, [name]: updatedValue }));

    const errorMessage = validateProperty(event);
    setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (errorMessage) {
            updatedErrors[name] = errorMessage;
        } else {
            delete updatedErrors[name];
        }
        return updatedErrors;
    });
};



  //Vérifie si la règle de validation est validé ou pas
  const validateProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaAddData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };

  //Une fonction pour vider les champs du formulaire
  const clearForm = () => {
    setAddFormData({
      libellePeriodiciteScolaire: '',
      descriptionPeriodiciteScolaire: '',
      dateDebutPeriodiciteScolaire: '',
      dateFinPeriodiciteScolaire: '',
      anneeacademiqueId: ''
    });
  };

  //suppression d'un élément
  const onDelete = (param) => {
    //confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        PeriodicitesScolairesService.delete(param, token).then((response) => {
          //console.log(response.data)
          if (response.data.status !== 200) {
            Swal.fire({
              icon: "error",
              text: response.data.message,
            });
          } else {
            Swal.fire({
              icon: "success",
              text: response.data.message,
            });
            fetchPeriodicites();
          }
        })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              text: e.message,
            });
            console.log(e);
          });
      }
    });
  };


  //Gérer les changements sur les formulaires de modification
  const handleEditChange = (event) => {
    const { name, value } = event.target;
  
    // Parse value if it's `anneeacademiqueId`
    const updatedValue = name === 'anneeacademiqueId' ? parseInt(value) : value;
    setEditFormData((prevData) => ({ ...prevData, [name]: updatedValue }));
  
    let errorData = { ...errors };
    const errorMessage = validateEditProperty(event);
    
    // Set or delete error based on validation
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      delete errorData[name];
    }
    setErrors(errorData);
  };
  


  //Vérifie si la règle de validation est validé ou pas
  const validateEditProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaEditData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };


  //Enregistrer un nouveau Periodicites
  const handleStore = async (event) => {
    event.preventDefault()
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(addFormData,
      schemaAddData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {
      //
      await PeriodicitesScolairesService.store(addFormData, token).then(response => {
        //Fermer le modal
        setIsVisible(false)
        //Vider les champs du formulaire
        clearForm()
        if (response.data.status === 200) {

          //Mettre à jour la liste des Periodicites
          fetchPeriodicites()
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });

        }
      }).catch(error => {
        setIsVisible(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        console.log(error);
      })
    }
  }

  ///Content du modal d'ajout de genre
  const addModalContent = (
    <Form className="needs-validation row" noValidate onSubmit={handleStore}>
      <div className="col-md-12 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          Libelle <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="bs-validation-libellePeriodiciteScolaire"
          type="text"
          value={addFormData.libellePeriodiciteScolaire}
          onChange={handleChange}
          required={true}
          name="libellePeriodiciteScolaire"
        />

        {errors.libellePeriodiciteScolaire && (
          <div className="alert alert-danger">
            {errors.libellePeriodiciteScolaire}
          </div>
        )}
      </div>
      <div className="col-md-6 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          Date debut <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="bs-validation-dateDebutPeriodiciteScolaire"
          type="date"
          value={addFormData.dateDebutPeriodiciteScolaire}
          onChange={handleChange}
          required={true}
          name="dateDebutPeriodiciteScolaire"
        />

        {errors.dateDebutPeriodiciteScolaire && (
          <div className="alert alert-danger">
            {errors.dateDebutPeriodiciteScolaire}
          </div>
        )}
      </div>

      <div className="col-md-6 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          Date fin <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="bs-validation-dateFinPeriodiciteScolaire"
          type="date"
          value={addFormData.dateFinPeriodiciteScolaire}
          onChange={handleChange}
          required={true}
          name="dateFinPeriodiciteScolaire"
        />

        {errors.dateFinPeriodiciteScolaire && (
          <div className="alert alert-danger">
            {errors.dateFinPeriodiciteScolaire}
          </div>
        )}
      </div>

      <div className=" col-md-12 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          anneesacademique <i className="text-danger">*</i>
        </Form.Label>
        <Form.Select className="select2 form-select form-select-md" name="anneeacademiqueId" id="bs-validation-anneeacademiqueId" value={addFormData.anneeacademiqueId} onChange={handleChange} required>
          <option value="">Sélectionnez une valeur</option>
          {anneesacademiques.length > 0 &&
            anneesacademiques.map(item => (
              <option key={item.id} value={item.id}>
                {item.anneedebutAnneeacademique} - {item.anneefinAnneeacademique}
              </option>
            ))}
        </Form.Select>

        {errors.anneeacademiqueId && (
          <div className="alert alert-danger">
            {errors.anneeacademiqueId}
          </div>
        )}

      </div>

      <div className="col-md-12 mb-2">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionPeriodiciteScolaire" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionPeriodiciteScolaire"
          onChange={handleChange}
          name="descriptionPeriodiciteScolaire"
          rows="3"
          value={addFormData.descriptionPeriodiciteScolaire}
        ></textarea>

        {errors.descriptionPeriodiciteScolaire && (
          <div className="alert alert-danger">
            {errors.descriptionPeriodiciteScolaire}
          </div>
        )}
      </div>


      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setIsVisible(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );

  ///Lancer le modal d'edition
  const lauchEdit = async (id) => {
    await PeriodicitesScolairesService.show(id, token).then((response) => {
      const data = response.data.data;
      console.log('edit',response.data.data)
      setEditFormData({
        
          libellePeriodiciteScolaire: data.libellePeriodiciteScolaire,
          descriptionPeriodiciteScolaire: data.descriptionPeriodiciteScolaire,
          dateDebutPeriodiciteScolaire: new Date(data.dateDebutPeriodiciteScolaire).toISOString().split('T')[0], // pour le format date
          dateFinPeriodiciteScolaire: new Date(data.dateFinPeriodiciteScolaire).toISOString().split('T')[0],
          anneeacademiqueId: data.anneesacademiques ? data.anneesacademiques.id : '',
          id: data.id
      
      })
      setEditModal(true)

    }).catch((error) => {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    });
  }

  //Modification d'un niveau
  const handleUpdate = async (event) => {
    event.preventDefault()
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(editFormData,
      schemaEditData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {

      //
      await PeriodicitesScolairesService.update(editFormData, token).then(response => {
        //Fermer le modal
        setEditModal(false)
        if (response.data.status === 200) {

          //Mettre à jour la liste des Periodicites
          fetchPeriodicites()
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });

        }
      }).catch(error => {
        //Fermer le modal
        setEditModal(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        console.log(error);
      })
    }
  }

  ///Content du modal d'edition de niveau
  const editModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
      <div className="row">
        <div className="col-md-12 col-sm-12">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Libelle <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-libellePeriodiciteScolaire"
            type="text"
            value={editFormData.libellePeriodiciteScolaire}
            onChange={handleEditChange}
            required={true}
            name="libellePeriodiciteScolaire"
          />

          {errors.libellePeriodiciteScolaire && (
            <div className="alert alert-danger">
              {errors.libellePeriodiciteScolaire}
            </div>
          )}
        </div>
        <div className="col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Date debut <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-dateDebutPeriodiciteScolaire"
            type="date"
            value={editFormData.dateDebutPeriodiciteScolaire}
            onChange={handleEditChange}
            required={true}
            name="dateDebutPeriodiciteScolaire"
          />

          {errors.dateDebutPeriodiciteScolaire && (
            <div className="alert alert-danger">
              {errors.dateDebutPeriodiciteScolaire}
            </div>
          )}
        </div>

        <div className="col-md-6 mb-3">
          <Form.Label
            className="form-label fw-bold"
            htmlFor="bs-validation-name"
          >
            Date fin <i className="text-danger">*</i>
          </Form.Label>
          <Form.Control
            className="form-control"
            id="bs-validation-dateFinPeriodiciteScolaire"
            type="date"
            value={editFormData.dateFinPeriodiciteScolaire}
            onChange={handleEditChange}
            required={true}
            name="dateFinPeriodiciteScolaire"
          />

          {errors.dateFinPeriodiciteScolaire && (
            <div className="alert alert-danger">
              {errors.dateFinPeriodiciteScolaire}
            </div>
          )}
        </div>

      </div>

      <div className=" col-md-12 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          anneesacademique <i className="text-danger">*</i>
        </Form.Label>
        <Form.Select className="select2 form-select form-select-md" name="anneeacademiqueId" id="bs-validation-anneeacademiqueId" value={editFormData.anneeacademiqueId} onChange={handleEditChange} required>
          <option value="">Sélectionnez une valeur</option>
          {anneesacademiques.length > 0 &&
            anneesacademiques.map(item => (
              <option key={item.id} value={item.id}>
                {item.anneedebutAnneeacademique} - {item.anneefinAnneeacademique}
              </option>
            ))}
        </Form.Select>

        {errors.anneeacademiqueId && (
          <div className="alert alert-danger">
            {errors.anneeacademiqueId}
          </div>
        )}

      </div>

      <div className="row mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionPeriodiciteScolaire" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionPeriodiciteScolaire"
          onChange={handleEditChange}
          name="descriptionPeriodiciteScolaire"
          rows="3"
          value={editFormData.descriptionPeriodiciteScolaire}
        ></textarea>

        {errors.descriptionPeriodiciteScolaire && (
          <div className="alert alert-danger">
            {errors.descriptionPeriodiciteScolaire}
          </div>
        )}

      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setEditModal(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );


  useEffect(() => {
    fetchPeriodicites();
    fetchAnneeacademique();
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }

  },[token], [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        {/* Responsive Datatable */}
        <div className="card mb-3 mt-3">
          <h5 className="card-header">
            Liste des périodicités scolaires &nbsp;&nbsp;
            <Button className="rounded-5" variant="primary" onClick={() => setIsVisible(true)} title="Ajouter">
              <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter une périodicité </Button>
          </h5>

          <div className="card-datatable table-responsive px-4 pb-3">
            <table className="dt-responsive table border-top data-table table-hover ">
              <thead className="bg-primary">
                <tr style={{ color: "white" }}>
                  <th className="cell text-white">#</th>
                  <th className="cell text-white">Libelle</th>
                  <th className="cell text-white">Description</th>
                  <th className="cell text-white">Date début</th>
                  <th className="cell text-white">Date fin</th>
                  <th className="cell text-white">Date modifcation</th>
                  <th className="cell text-white">Action</th>
                </tr>
              </thead>
              <tbody>
                {periodicites.length > 0 &&
                  periodicites.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">{index + 1}</td>
                      <td className="cell">{item.libellePeriodiciteScolaire}</td>
                      <td className="cell">
                        <span className="truncate">{item.descriptionPeriodiciteScolaire}</span>
                      </td>
                      <td className="cell">
                        {dayjs(item.dateDebutPeriodiciteScolaire).format("DD/MM/YYYY")}
                      </td>
                      <td className="cell">
                        {dayjs(item.dateFinPeriodiciteScolaire).format("DD/MM/YYYY H:m:s")}
                      </td>
                      <td className="cell">
                        <span>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}
                        </span>
                      </td>
                      <td className="cell">
                        <Button onClick={() => lauchEdit(item.id)}
                          className="btn btn-sm" severity="warning" style={{ color: "white" }}
                          title="Modifier"
                        >
                          <i className="fas fa-edit"></i>
                        </Button> &nbsp; &nbsp;
                        <Button
                          className="btn btn-sm" style={{ backgroundColor: "red", color: "white", border: "1px solid red" }}
                          onClick={() => onDelete(item.id)}
                          title="Supprimer"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}
      </div>

      {/* Modal Ajout des périodicités*/}
      <CustomAddModal
        modalTitle="Enregistrement périodicité"
        modalContent={addModalContent}
        visible={isVisible}
        close={() => setIsVisible(false)}
      />

      {/**End Modal Ajout des périodicités*/}

      {/* Modal Edition des périodicités*/}
      <CustomEditModal
        modalTitle="Modification périodicité"
        modalContent={editModalContent}
        visible={editModal}
        close={() => setEditModal(false)}
      />

      {/**End Modal Edition des périodicités*/}
    </Layout>
  );
}
